// extracted by mini-css-extract-plugin
export var content = "_ao-3";
export var list = "_ao-4";
export var settingsContent = "_ao-7";
export var settingsPanel = "_ao-8";
export var state = "_ao-6";
export var triggerBadge = "_ao-2";
export var triggerButton = "_ao-1";
export var triggerShell = "_ao-0";
export var unreadDot = "_ao-5";